import {
  IgAzurePrimitives,
  IgGrayPrimitives,
  IgGreenPrimitives,
  IgRedPrimitives,
  IgYellowPrimitives,
} from "@intelligems/ig-design-tokens";
import { WorkspaceLogEntry, WorkspaceLogLevel } from "../types";

const LOG_LEVEL_COLOR: Record<WorkspaceLogLevel, string> = {
  log: IgGrayPrimitives[800],
  info: IgAzurePrimitives[800],
  warn: IgYellowPrimitives[400],
  error: IgRedPrimitives[800],
  debug: IgGreenPrimitives[300],
};

export const formatLogEntry = (log: WorkspaceLogEntry): string => {
  const details =
    log.details === undefined ? "" : ` ${JSON.stringify(log.details)}`;
  return `${log.level.toUpperCase()} ${log.message}${details}`;
};

export const LogEntryLine = ({ log }: { log: WorkspaceLogEntry }) => (
  <span style={{ color: LOG_LEVEL_COLOR[log.level] }}>
    {formatLogEntry(log)}
  </span>
);
